(function () {
  if (window.__wethemeAddToCartPriceAttached) {
    return;
  }
  window.__wethemeAddToCartPriceAttached = true;

  window.wetheme = window.wetheme || {};

  function formatMoney(cents) {
    if (window.wetheme && typeof window.wetheme.formatMoney === 'function') {
      const formattedMoney = window.wetheme.formatMoney(cents);
      if (typeof formattedMoney === 'string' && formattedMoney.includes('<')) {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = formattedMoney;
        return (tempContainer.textContent || '').trim();
      }
      return formattedMoney;
    }

    return String(cents);
  }

  function getQuantityForPrice(priceEl) {
    const productInfo = priceEl.closest('product-information');
    const productForm = priceEl.closest('product-form');
    const visibleInput = productInfo ? productInfo.querySelector('[name="quantity-js"]') : null;
    const hiddenInput = productForm ? productForm.querySelector('[name="quantity"]') : null;
    const raw =
      (visibleInput && visibleInput.value) || (hiddenInput && hiddenInput.value) || '1';
    const quantity = parseInt(raw, 10);

    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function updatePrice(priceEl, quantityOverride) {
    const unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
    if (Number.isNaN(unitPrice)) {
      return;
    }

    let quantity;
    if (
      quantityOverride !== undefined &&
      quantityOverride !== null &&
      quantityOverride !== ''
    ) {
      const parsed = parseInt(quantityOverride, 10);
      quantity = Number.isNaN(parsed) || parsed < 1 ? getQuantityForPrice(priceEl) : parsed;
    } else {
      quantity = getQuantityForPrice(priceEl);
    }

    const totalPrice = unitPrice * quantity;
    const prefix = priceEl.dataset.pricePrefix || '';

    priceEl.innerHTML = `${prefix}${formatMoney(totalPrice)}`;
  }

  function updateSectionPrices(sectionId, quantity) {
    document.querySelectorAll('[data-add-to-cart-price][data-unit-price]').forEach((priceEl) => {
      if (sectionId && priceEl.dataset.sectionId !== String(sectionId)) {
        return;
      }
      updatePrice(priceEl, quantity);
    });
  }

  function initPrices(root) {
    const searchRoot = root && root.querySelectorAll ? root : document;
    searchRoot.querySelectorAll('[data-add-to-cart-price][data-unit-price]').forEach((priceEl) => {
      if (root && root !== document && root.nodeType === 1 && !root.contains(priceEl)) {
        return;
      }
      updatePrice(priceEl);
    });
  }

  function getSectionIdFromTarget(target) {
    const productInformation = target.closest('product-information');
    if (!productInformation) {
      return null;
    }

    return productInformation.getAttribute('data-section-id');
  }

  function handleQuantityInputChange(event) {
    const target = event.target;
    if (!target || !target.matches('[name="quantity"], [name="quantity-js"]')) {
      return;
    }

    const quantity = parseInt(target.value, 10);
    const sectionId = getSectionIdFromTarget(target);

    updateSectionPrices(sectionId, quantity);
  }

  function handleQuantityAdjustClick(event) {
    const button = event.target.closest('.js-qty__adjust');
    if (!button) {
      return;
    }

    const sectionId = getSectionIdFromTarget(button);

    setTimeout(() => {
      updateSectionPrices(sectionId);
    }, 0);
  }

  window.wetheme.syncAddToCartButtonPrices = initPrices;

  if (window.eventBus && typeof window.eventBus.on === 'function') {
    window.eventBus.on('qty:change', (event) => {
      if (!event || !event.value) {
        return;
      }

      updateSectionPrices(event.sectionId, parseInt(event.value, 10));
    });

    window.eventBus.on('product:modal:ready', () => {
      const modalInner = document.querySelector(
        '#ThemeModal [data-modal-content] .theme-modal--inner'
      );
      if (modalInner) {
        initPrices(modalInner);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPrices(document);
  });

  document.addEventListener('input', handleQuantityInputChange);
  document.addEventListener('change', handleQuantityInputChange);
  document.addEventListener('click', handleQuantityAdjustClick);
})();
